import { Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-confirm-info-modal',
  templateUrl: './confirm-info-modal.component.html',
  styleUrls: ['./confirm-info-modal.component.scss']
})
export class ConfirmInfoModalComponent {
  @ViewChild('confirmationModal') confirmInfoTemplate!: TemplateRef<ConfirmInfoModalComponent>;
  @Output() okBtnClicked = new EventEmitter<any>();

  okClicked(){
    this.okBtnClicked.emit();
  }
}
